import styled from '@emotion/styled';

export const DataUploadListPage = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  margin: auto;
  gap: 1rem;
`;

export const PageSpinnerContainer = styled.div`
  margin: auto;
  width: 100%;
  padding: 10px;
`;

export const SearchForm = styled.div``;
